import { RouteObject } from "react-router";

export const ErrorRoutes: RouteObject = {
	path: "*",
	lazy: async () => {
		const { NotFound } = await import("@/app/application/NotFound");
		return { Component: NotFound };
	},
};
